import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  ACCOUNTING_ENV,
} from "../../config/micros-env.tokens";
import { EnvMicroAccounting } from "../../config/env.micro.accounting";
import { WalletPayablesSummaryResponse } from "../../../domain/models/accounting/wallet-payables.model";
import { WalletPayablesPort } from "../../../app/ports/accounting/wallet-payables.port";
import { isWalletPayablesSummaryResponse } from "../../validators/accounting/wallet-payables.validator";

@Injectable()
export class WalletPayablesHttpAdapter implements WalletPayablesPort {
  private static readonly SUMMARY_PATH = "/api/v1/wallet-payables/summary";

  constructor(
    private readonly http: HttpClient,
    @Inject(ACCOUNTING_ENV) private readonly env: EnvMicroAccounting,
  ) {}

  getSummary(companyId: number, periodId: number): Observable<WalletPayablesSummaryResponse> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    const params = new HttpParams()
      .set("idCompany", companyId)
      .set("idPeriod", periodId);

    return this.http.get<unknown>(`${baseUrl}${WalletPayablesHttpAdapter.SUMMARY_PATH}`, { params }).pipe(
      map((response) => {
        if (!isWalletPayablesSummaryResponse(response)) {
          throw new Error("La respuesta del resumen de wallet por pagar es inválida.");
        }
        return response;
      }),
    );
  }
}
